// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtClaimFileOutputModel {
    static getAttributeTypeMap() {
        return ExtClaimFileOutputModel.attributeTypeMap;
    }
}
ExtClaimFileOutputModel.discriminator = undefined;
ExtClaimFileOutputModel.additionalProperties = false;
ExtClaimFileOutputModel.attributeTypeMap = [
    {
        "name": "fileIdentifier",
        "baseName": "fileIdentifier",
        "type": "string"
    },
    {
        "name": "fileName",
        "baseName": "fileName",
        "type": "string"
    },
];
//# sourceMappingURL=extClaimFileOutputModel.js.map